import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type MegaphoneIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const MegaphoneIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: MegaphoneIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9984 14.9999L7.00038 14.9979C4.79138 14.9979 3.00038 13.2059 3.00038 10.9959V9.99891C3.00038 7.78891 4.79138 5.99791 7.00138 5.99791H13.9994L17.8714 3.35191C19.1994 2.44491 21.0004 3.39591 21.0004 5.00391V15.9959C21.0004 17.6039 19.1984 18.5549 17.8714 17.6469L13.9984 14.9999Z"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 5.99975V14.9997"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00018 14.9997L7.52918 18.8577C7.80218 19.5477 8.46418 19.9997 9.19918 19.9997V19.9997C10.4702 19.9997 11.3402 18.7057 10.8712 17.5127L9.88218 14.9997"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
